module.exports = __webpack_public_path__ + "static/js/1.613bab92.chunk.worker.js"